import dayjs from 'dayjs'

export const CHART_COLORS = {
  primary: 'rgb(102, 126, 234)',
  primaryBackground: 'rgba(102, 126, 234, 0.1)',
  secondary: 'rgb(245, 87, 108)',
  secondaryBackground: 'rgba(245, 87, 108, 0.1)',
  success: 'rgb(76, 175, 80)',
  successBackground: 'rgba(76, 175, 80, 0.1)',
  warning: 'rgb(255, 193, 7)',
  warningBackground: 'rgba(255, 193, 7, 0.1)',
} as const

export const getDefaultLineChartOptions = () => ({
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      position: 'top' as const,
    },
    tooltip: {
      mode: 'index' as const,
      intersect: false,
    },
  },
  scales: {
    y: {
      beginAtZero: true,
      ticks: {
        precision: 0,
      },
    },
  },
})

export const formatChartDateLabels = (dates: string[]): string[] => {
  return dates.map((date) => dayjs(date).format('DD/MM/YYYY'))
}

export const createLineDataset = (label: string, data: number[], colorKey: keyof typeof CHART_COLORS, backgroundColorKey: keyof typeof CHART_COLORS) => ({
  label,
  data,
  borderColor: CHART_COLORS[colorKey],
  backgroundColor: CHART_COLORS[backgroundColorKey],
  tension: 0.4,
  fill: true,
})
